<template>
    <div>
        <div v-if="organizationName">
            <h2 class="text-2xl font-medium text-left">{{ organizationName }}</h2>
        </div>
        <div v-if="contactName">
            <h2 class="text-left text-xl mb-[3%] font-normal">
                {{ contactName }} ({{ contactId }})
            </h2>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { defineProps } from 'vue'

    const props = defineProps({
        organizationName: String,
        contactName: String,
        contactId: [String, Number],
    })
</script>
